import { c as _c } from "react/compiler-runtime";
export default function Chat(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M26 7a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-4v4.5a1.25 1.25 0 0 1-2 1L12.667 25H6a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h20zm0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6.667a2 2 0 0 1 1.2.4L20 28v-3.8a1.2 1.2 0 0 1 1.2-1.2H26a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1zm-15 5.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5.003 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}